import React from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core';

interface Props {
  onAddNew: () => void;
}

const AuthorizedUsersHeader: React.FC<Props> = ({ onAddNew }) => {
  const hasEditPermission = useHasAccess([{ permission: Permissions.EDIT_AUTHORIZED_USERS }]);

  return (
    <Box
      direction="row"
      justify="between"
      align="center"
      data-testid="authorized-users_header"
    >
      <Text size="20px" weight={400} color="textTitle" data-testid="authorized-users_header_title">
        Authorized Users
      </Text>
      {hasEditPermission && (
        <AppButton
          testId="authorized-users_header_add-btn"
          buttonType="secondary"
          width="176px"
          onClick={onAddNew}
        >
          Add Authorized User
        </AppButton>
      )}
    </Box>
  );
};

export default AuthorizedUsersHeader;
